import axios from 'axios';

const API_BASE_URL = '/api/exams';

const examsService = {
  // Get all exams with pagination and filters
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE_URL, {
      params,
      withCredentials: true
    });
    return response.data;
  },

  // Get single exam by ID
  getById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/${id}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Create new exam
  create: async (data) => {
    const response = await axios.post(API_BASE_URL, data, {
      withCredentials: true
    });
    return response.data;
  },

  // Update exam
  update: async (id, data) => {
    const response = await axios.put(`${API_BASE_URL}/${id}`, data, {
      withCredentials: true
    });
    return response.data;
  },

  // Delete exam
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/${id}`, {
      withCredentials: true
    });
    return response.data;
  }
};

export default examsService;

